package ru.chm.gradereport.ui.screens.course.sheet

import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.heightIn
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.widthIn
import androidx.compose.foundation.rememberScrollState
import androidx.compose.foundation.verticalScroll
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import androidx.compose.ui.window.Dialog
import ru.chm.gradereport.model.LessonSessionDto
import ru.chm.gradereport.ui.components.AppCard
import ru.chm.gradereport.ui.components.AppTextField
import ru.chm.gradereport.ui.components.DatePickerField
import ru.chm.gradereport.ui.components.formatDisplayDate
import ru.chm.gradereport.ui.components.MutedText
import ru.chm.gradereport.ui.components.PrimaryButton
import ru.chm.gradereport.ui.components.SecondaryButton
import ru.chm.gradereport.ui.components.SelectableText
import ru.chm.gradereport.ui.components.SoftDeleteButton
import ru.chm.gradereport.ui.theme.GradeTheme

@Composable
internal fun SessionDetailsDialog(
    session: LessonSessionDto,
    editable: Boolean,
    onDismiss: () -> Unit,
    onSave: (date: String, title: String, description: String) -> Unit,
    onDelete: () -> Unit,
) {
    var date by remember(session.id, session.date) { mutableStateOf(session.date) }
    var title by remember(session.id, session.title) { mutableStateOf(session.title) }
    var description by remember(session.id, session.description) { mutableStateOf(session.description) }
    val canSave = date.isNotBlank() &&
        (
            date.trim() != session.date ||
                title.trim() != session.title ||
                description.trim() != session.description
            )

    Dialog(onDismissRequest = onDismiss) {
        AppCard(
            modifier = Modifier
                .fillMaxWidth()
                .padding(horizontal = 12.dp)
                .widthIn(max = 480.dp)
                .verticalScroll(rememberScrollState()),
        ) {
            Text(
                "Занятие",
                color = GradeTheme.colors.textPrimary,
                fontWeight = FontWeight.Bold,
                fontSize = 20.sp,
            )

            if (editable) {
                DatePickerField(
                    value = date,
                    onValueChange = { date = it },
                    label = "Дата",
                    modifier = Modifier.padding(top = 12.dp),
                )
                AppTextField(
                    value = title,
                    onValueChange = { title = it },
                    label = "Тема занятия",
                    modifier = Modifier.padding(top = 8.dp),
                )
                AppTextField(
                    value = description,
                    onValueChange = { description = it },
                    label = "Описание темы",
                    modifier = Modifier.padding(top = 8.dp).heightIn(min = 96.dp),
                    singleLine = false,
                )
            } else {
                SelectableText(
                    text = session.title.ifBlank { "Занятие" },
                    color = SessionAccent,
                    fontWeight = FontWeight.SemiBold,
                    fontSize = 18.sp,
                    modifier = Modifier.padding(top = 10.dp),
                )
                if (session.date.isNotBlank()) {
                    MutedText(formatDisplayDate(session.date), modifier = Modifier.padding(top = 6.dp))
                }
                if (session.description.isNotBlank()) {
                    SelectableText(
                        text = session.description,
                        color = GradeTheme.colors.textPrimary,
                        fontSize = 15.sp,
                        lineHeight = 22.sp,
                        modifier = Modifier.padding(top = 12.dp),
                    )
                } else {
                    MutedText(
                        "Описание не указано.",
                        modifier = Modifier.padding(top = 12.dp),
                    )
                }
            }

            Row(
                modifier = Modifier.fillMaxWidth().padding(top = 16.dp),
                horizontalArrangement = Arrangement.spacedBy(8.dp),
                verticalAlignment = Alignment.CenterVertically,
            ) {
                if (editable) {
                    SoftDeleteButton(
                        text = "Удалить",
                        onClick = onDelete,
                        modifier = Modifier.weight(1f),
                    )
                    PrimaryButton(
                        text = "Сохранить",
                        enabled = canSave,
                        onClick = {
                            onSave(
                                date.trim(),
                                title.trim().ifBlank { date.trim() },
                                description.trim(),
                            )
                        },
                        modifier = Modifier.weight(1f),
                    )
                }
                SecondaryButton(
                    text = "Закрыть",
                    onClick = onDismiss,
                    modifier = Modifier.weight(1f),
                )
            }
        }
    }
}
